import LedgerLetterIcon from './LedgerLetterIcon'

export default LedgerLetterIcon
